import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { Auth } from '../services/auth.service';
import { LoginPrompt } from '../services/login-prompt.service';

const PROTECTED_ROUTE_PREFIXES = ['/admin', '/profile'];
const AUTH_ENDPOINT_SEGMENT = '/auth/';

const isProtectedRoute = (url: string): boolean =>
  PROTECTED_ROUTE_PREFIXES.some(prefix => url === prefix || url.startsWith(`${prefix}/`) || url.startsWith(`${prefix}?`));

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(Auth);
  const router = inject(Router);
  const loginPrompt = inject(LoginPrompt);
  const token = auth.getToken();

  const authReq = token && !req.headers.has('Authorization')
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || !authReq.headers.has('Authorization') || req.url.includes(AUTH_ENDPOINT_SEGMENT)) {
        return throwError(() => error);
      }
      auth.expireSession();
      if (isProtectedRoute(router.url)) {
        router.navigate(['/']);
        loginPrompt.require('Tu sesión expiró. Inicia sesión nuevamente.', 'Sesión expirada');
        return throwError(() => error);
      }
      if (req.method === 'GET') {
        return next(req.clone({ headers: req.headers.delete('Authorization') }));
      }
      return throwError(() => error);
    })
  );
};
